/**
 * gravity-forms-utm-fill-force.js
 *
 * @desc Checks if Handl's traffic_source and organic_source_str cookies are set, and force those into gravity fields
 * @version 1.0
 */

const cookie_list = {
	utm_medium: "traffic_source",
	utm_source: "organic_source_str",
};

function getCookie(name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(";").shift();
	}
	return false;
}

function applyMutation(mutationList, observer) {
	mutationList.forEach((mutation) => {
		switch (mutation.type) {
			case "attributes":
				const cookie_name = cookie_list[mutation.target.dataset.cookieAutofill];
				const cookie_value = getCookie(cookie_name);
				if (cookie_value) {
					// console.log("field: " + mutation.target.dataset.cookieAutofill);
					// console.log("field value before: " + mutation.target.value);
					// console.log("cookie name: " + cookie_name);
					// console.log("cookie_value: " + cookie_value);
					if (mutation.target.value === "" && mutation.target.value !== cookie_name) {
						mutation.target.value = cookie_value;
						// console.log("field value after: " + mutation.target.value);
					}
				}

				break;
		}
	});
}

jQuery(document).on("gform_post_render", function (event, form_id, current_page) {
	const form = document.getElementById("gform_" + form_id);

	for (const [form_field, cookie] of Object.entries(cookie_list)) {
		const fields = form.querySelectorAll("[data-cookie-autofill='" + form_field + "']");
		fields.forEach(function (field) {
			const targetNode = field;
			const observerOptions = {
				attributes: true,
			};

			const observer = new MutationObserver(applyMutation);
			observer.observe(targetNode, observerOptions);
		});
	}
});
